import React from 'react';
import { Mail } from 'lucide-react';

/**
 * Newsletter Opt-In Checkbox Component
 * Use this in registration forms, checkout, donations, etc.
 * 
 * Props:
 * - checked: boolean - Current opt-in state
 * - onChange: (checked: boolean) => void - Handler for state changes
 * - source: string - Where the opt-in came from ('website_form', 'checkout', 'donation', 'admin')
 * - className: string - Additional classes for the container
 */
const NewsletterOptIn = ({ 
  checked = false, 
  onChange, 
  source = 'website_form',
  className = '' 
}) => {
  return (
    <div className={`bg-stone-50 border border-stone-200 rounded-lg p-4 ${className}`}>
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-1 w-4 h-4 rounded border-stone-300 text-cafa-red focus:ring-cafa-red"
          data-testid="newsletter-opt-in-checkbox"
        />
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <Mail size={16} className="text-cafa-red" />
            <span className="font-medium text-stone-900 text-sm">Subscribe to Our Newsletter</span>
          </div>
          <p className="text-xs text-stone-600 leading-relaxed">
            Stay updated with the latest classes, workshops, events, and news from The Coppini Academy of Fine Art. 
            You can unsubscribe at any time.
          </p>
        </div>
      </label>
      <p className="text-xs text-stone-400 mt-2 pl-7">
        By checking this box, you consent to receive marketing emails from CAFA. 
        We respect your privacy and will never share your information.
      </p>
    </div>
  );
};

export default NewsletterOptIn;
